/* Jolly Designs – Homepage redesign (jdh-*) – sliders + lazy videos */
(function () {
  if (window.__jdhHome) return; window.__jdhHome = true;
  function initSlider(root) {
    if (root.__jdh) return; root.__jdh = true;
    var track = root.querySelector('.jdh-slider__track');
    var dots = root.querySelector('.jdh-dots');
    if (!track || !dots) return;
    var pages = 1;
    function build() {
      var scrollable = track.scrollWidth - track.clientWidth;
      pages = scrollable > 8 ? Math.min(8, Math.ceil(track.scrollWidth / track.clientWidth - 0.05)) : 1;
      dots.innerHTML = '';
      dots.hidden = pages < 2;
      for (var i = 0; i < pages; i++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Seite ' + (i + 1));
          b.addEventListener('click', function () {
            var max = track.scrollWidth - track.clientWidth;
            track.scrollTo({ left: pages > 1 ? (max * i) / (pages - 1) : 0, behavior: 'smooth' });
          });
          dots.appendChild(b);
        })(i);
      }
      update();
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var idx = max > 0 ? Math.round((track.scrollLeft / max) * (pages - 1)) : 0;
      [].forEach.call(dots.children, function (b, i) { b.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(build, 150); });
    build();
    setTimeout(build, 1200);
  }
  function initVideos(scope) {
    var vids = scope.querySelectorAll('video.jdh-video:not([data-jdh-init])');
    if (!vids.length) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.dataset.jdhStarted) { v.dataset.jdhStarted = '1'; v.preload = 'auto'; try { if (v.readyState === 0) v.load(); } catch (_) {} }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (v.dataset.jdhStarted) { v.pause(); }
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 }) : null;
    [].forEach.call(vids, function (v) {
      v.dataset.jdhInit = '1'; v.muted = true;
      if (io) io.observe(v);
      var btn = v.parentNode.querySelector('[data-jdh-sound]');
      if (!btn) return;
      function set(on) { btn.classList.toggle('is-on', on); btn.setAttribute('aria-pressed', on ? 'true' : 'false'); btn.setAttribute('aria-label', on ? 'Ton ausschalten' : 'Ton einschalten'); }
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (v.muted) {
          [].forEach.call(document.querySelectorAll('video.jdh-video'), function (o) { if (o !== v) o.muted = true; });
          v.muted = false; v.volume = 1; var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.muted = true; }
      });
      v.addEventListener('volumechange', function () { set(!v.muted); });
    });
  }
  function init(scope) {
    scope = scope || document;
    [].forEach.call(scope.querySelectorAll('[data-jdh-slider]'), initSlider);
    initVideos(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
